import { useTranslation } from "react-i18next";
import { useLanguage } from "../useLanguage";

export const use404Translations = () => {
  const { t } = useTranslation();

  // Habilitar detección del idioma del navegador para la página 404
  useLanguage({ enableBrowserDetection: true });

  return {
    t,
    translations: {
      title: t("404:title"),
      subtitle: t("404:subtitle"),
      description: t("404:description"),
      button: t("404:button"),
    },
  };
};
